import "./FooterStyles.css"

import React from 'react'

import {FaHome, FaPhone, FaMailBulk} from "react-icons/fa"
import { useTranslation } from "react-i18next"

const  Footer = () => {
const { t } = useTranslation()    
return (
    <div className="footer">
        <div className="footer-container">
            <div className="left">
                <div className="location">                 
                    <p><FaHome size={15} style={{color:"#ff", marginRight:"1rem"}}/>10th F, 200 Consilium Pl,Scarborough,ON M1H 3G2,Canada</p>                
                </div>
                <div className="phone">
                    <p><FaPhone size={15} style={{color:"#ff", marginRight:"1rem"}} />+1-647-503-7066</p>
                </div>
                <div className="email">
                    <p><FaMailBulk size={15} style={{color:"#ff", marginRight:"1rem"}} />oseelight@gmail.com</p>
                </div>
            </div>
            <div className="right">
                <h4>{t('footer.about')}</h4>
                <p>
                {t('footer.description')}
                </p>
            </div>
        </div>
        <div className="bottom">
                <p>Copyright © 2022 All rights reserved - O See Light IT Consulting</p>
                <div className="social">
                    <a href="#"><img src="images/m-f.png" width="30" height="30"/></a>
                    <a href="#"><img src="images/m-i.png" width="30" height="30"/></a>
                    <a href="#"><img src="images/m-t.png" width="30" height="30"/></a>
                    <a href="#"><img src="images/m-y.png" width="30" height="30"/></a>
                </div>
        </div>
    </div>
  )
}

export default Footer